"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReferralAsReferrerDto = instanceOfReferralAsReferrerDto;
exports.ReferralAsReferrerDtoFromJSON = ReferralAsReferrerDtoFromJSON;
exports.ReferralAsReferrerDtoFromJSONTyped = ReferralAsReferrerDtoFromJSONTyped;
exports.ReferralAsReferrerDtoToJSON = ReferralAsReferrerDtoToJSON;
exports.ReferralAsReferrerDtoToJSONTyped = ReferralAsReferrerDtoToJSONTyped;
/**
 * Check if a given object implements the ReferralAsReferrerDto interface.
 */
function instanceOfReferralAsReferrerDto(value) {
    if (!('total_referred' in value) || value['total_referred'] === undefined)
        return false;
    if (!('successful' in value) || value['successful'] === undefined)
        return false;
    if (!('invalidated' in value) || value['invalidated'] === undefined)
        return false;
    if (!('rewards_issued' in value) || value['rewards_issued'] === undefined)
        return false;
    if (!('pro_months_earned' in value) || value['pro_months_earned'] === undefined)
        return false;
    if (!('max_pro_months' in value) || value['max_pro_months'] === undefined)
        return false;
    if (!('max_successful_referrals' in value) || value['max_successful_referrals'] === undefined)
        return false;
    if (!('benefit_cap_reached' in value) || value['benefit_cap_reached'] === undefined)
        return false;
    return true;
}
function ReferralAsReferrerDtoFromJSON(json) {
    return ReferralAsReferrerDtoFromJSONTyped(json, false);
}
function ReferralAsReferrerDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'total_referred': json['total_referred'],
        'successful': json['successful'],
        'invalidated': json['invalidated'],
        'rewards_issued': json['rewards_issued'],
        'pro_months_earned': json['pro_months_earned'],
        'max_pro_months': json['max_pro_months'],
        'max_successful_referrals': json['max_successful_referrals'],
        'benefit_cap_reached': json['benefit_cap_reached'],
    };
}
function ReferralAsReferrerDtoToJSON(json) {
    return ReferralAsReferrerDtoToJSONTyped(json, false);
}
function ReferralAsReferrerDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'total_referred': value['total_referred'],
        'successful': value['successful'],
        'invalidated': value['invalidated'],
        'rewards_issued': value['rewards_issued'],
        'pro_months_earned': value['pro_months_earned'],
        'max_pro_months': value['max_pro_months'],
        'max_successful_referrals': value['max_successful_referrals'],
        'benefit_cap_reached': value['benefit_cap_reached'],
    };
}
